<template>
  <div class="auth">
    <div class="wrapper">
      <div class="auth__in">
        <div class="signup">
          <div class="auth-heading">
            <h2>{{ trans.text.login.signIn }}</h2>
            <p>{{ trans.text.login.dontHave }}
              <a :href="'/'+ lang +'/register'">{{ trans.text.login.registration }}</a>
            </p>
          </div>

          <div class="auth-form">
            <div :class="{'inp-error' : getEmailError}" class="inp-group">
              <label v-if="!getEmailError" for="signin-login">{{ trans.text.login.logIn }}</label>
              <span v-if="getEmailError" class="inp-error__text">{{ getEmailError }}</span>
              <input id="signin-login" v-model="email" class="inp-style inp-fw" name="#" type="text">
            </div>

            <div :class="{'inp-error' : getPassError}" class="inp-group">
              <label v-if="!getPassError && !getLoginError"
                     for="signin-pwd">{{ trans.text.login.password }}</label>
              <span v-if="getPassError" class="inp-error__text">{{ getPassError }}</span>
              <span v-if="getLoginError" class="inp-error__text__login">{{ getLoginError }}</span>
              <input id="signin-pwd" v-model="password" class="inp-style inp-fw" name="#" type="password">
            </div>

            <div class="inp-group">
              <a :href="'/'+ lang +'/forgotPwd'">{{ trans.text.login.forgot }}</a>
            </div>

            <div class="btn__wrapper-social">
              <button class="btn btn-green btn-submit size btn-sm" @click="submit">
                {{ trans.text.login.logInBtn }}
              </button>
              <a v-if="false" class="btn-apple" href="/api/auth/apple/login?register=false"></a>
              <facebook-login
                v-if="!fb_token"
                :ref="'fbBtn'"
                appId="560487734518765"
                class="btn btn-fb btn-sm"
                loginLabel=""
                logoutLabel=""
                @login="onLogin"
                @logout="onLogout"
                @get-initial-status="getUserData"
                @sdk-loaded="sdkLoaded">
              </facebook-login>
            </div>
          </div>
        </div>
        <loader-component v-show="showLoader"></loader-component>
      </div>
    </div>
  </div>
</template>
<script>
import {mapActions, mapGetters} from 'vuex'
import facebookLogin from 'facebook-login-vuejs';
import LoaderComponent from './LoaderComponent.vue';

export default {
  props: {
    'lang' : String,
    'trans': Object,
    'redirect': String,
    'showLoader': {
      type: Boolean,
      default: false
    }
  },

  components: {facebookLogin, LoaderComponent},
  data() {
    return {
      email: '',
      password: '',
      fb_token: null,
      isConnected: false,
      name: '',
      logged: false,
      personalID: '',
      FB: undefined
    }
  },
  computed: {
    ...mapGetters(['getEmailError', 'getPassError', 'getLoginError']),

  },
  mounted() {
    if (localStorage.getItem('access_token') && this.redirect !== 'checkout') {
      location.href = `/${this.lang}/profile`;
    }
  },
  methods: {
    ...mapActions(['Login', 'LoginByFaceBook']),
    getUserData() {
      if (this.FB) {
        this.FB.api('/me', 'GET', {fields: 'id,name,email'},
          userInformation => {
            this.personalID = userInformation.id;
            this.email = userInformation.email;
            this.name = userInformation.name;
          }
        )
      }
    },
    submit() {
//      console.log(this.redirect);
//      console.log(this.lang);
      this.Login({
        email: this.email,
        password: this.password,
        path: this.$path,
        lang: this.lang,
        redirect: this.redirect
      })
    },
    sdkLoaded(payload) {
      this.isConnected = payload.isConnected;
      this.FB = payload.FB;
      if (this.isConnected) this.getUserData()
    },
    onLogin(event) {
      if (!!event.response.authResponse) {
        this.isConnected = true;
        this.fb_token = event.response.authResponse.accessToken;
        this.getUserData();
        this.login();
      }
    },
    AppleLogin() {
    },
    login() {
      this.LoginByFaceBook({
        fb_token: this.fb_token,
        path: this.$path,
        lang: this.lang,
        register: false,
        redirect: this.redirect
      })
    },
    onLogout(event) {
      this.isConnected = false;
    },
  },
}
</script>
<style lang="scss" scoped>
.facebook-login {
  @media (min-width: 768px) {
    min-width: 54px;
  }
}

.facebook-login button {
  width: 54px !important;
  height: 54px !important;
  background: transparent !important;
}

.size {
  /*TODO: Change this value to calc(100% - 130px when enable apple auth )*/
  /*TODO: Change this value to calc(100% - 60px when disable apple auth )*/
  min-width: calc(100% - 60px) !important;
}

/*@supports (mask-image: paint(smooth-corners)) {*/
/*button {*/
/*border-radius: 0 !important;*/
/*mask-image: paint(smooth-corners);*/
/*--smooth-corners: 6;*/
/*}*/
/*}*/
.auth__in {
  position: relative;
}
</style>
